// extracted by mini-css-extract-plugin
module.exports = {"root":"_22b95433","icon":"_12f27cac","content":"_8329a63a","textBlock":"_6e162e42","text":"_396a1169","privacyLink":"_c22a105a","actions":"_7e3c6b48"};